"use strict"

import { Data } from '@/lib/core/components/data/data'
import { linkDataVersionsManager, fieldsToUpdate, updateInfo } from '@/lib/core/linkDataVersionsManager'
// Public
import { LotesDM } from '@/lib/core/public/lotes'
import { IPTUsDM } from '@/lib/core/public/iptus'
import { VTOsDM } from '@/lib/core/public/vtos'
import { ITBIsDM } from '@/lib/core/public/itbis'
// Terrenos
import { StatusLotes } from '@/lib/core/terrenos/statusLotes'
import { TerrenosLotesForm } from '@/lib/core/terrenos/terrenosLotesForm'
import { TerrenosLotesDM } from '@/lib/core/terrenos/terrenosLotes'
// Form
import { FieldText } from '@/lib/core/components/data/form/FieldText'
import { FieldSelect } from '@/lib/core/components/data/form/FieldSelect'
import { FieldLinkSimple } from '@/lib/core/components/data/form/FieldLinkSimple'
import { FieldButton } from '@/lib/core/components/data/form/FieldButton'
import { multilines } from '@/lib/core/components/data/form/multilines'
// Lib
import * as jsf from '@/lib/js_functions'
import * as get_info from '@/lib/get_info'

import { dialog } from '@/lib/core/components/dialog'

export class LotesForm extends Data {
  #ref
  #form
  #register
  #fields
  #Logic
  #LDVM
  constructor({ ref, Logic }) {
    const cache = ({ dataId, query, project }) => { return {
      'name': 'maps/db/polygons',
      'url': `public/lotes.json/dataId=${dataId}/query=${JSON.stringify(query)}/project=${JSON.stringify(project)}`
    } }
    const LDVM = new linkDataVersionsManager({ company: 'public', dataVersionName: 'lotes' })
    const lastDataId = LDVM.getLastDataId()
    super({ company: 'public', module: 'data', dataId: lastDataId, Logic, originClass: LotesDM, cache })
    this.#ref = ref
    this.#Logic = Logic
    this.#LDVM = LDVM
  }
  get LDVM() { return this.#LDVM }
  async configForm({ register, fields }) {
    this.#register = register
    this.#fields = fields
    await this.#ref.lotes?.build({ linkDataVersionsManager: this.#LDVM })
    this.#LDVM.setLinkDataVersion({ register, versionDataId: this.#ref.lotes?.currentDataId })
    this.#ref.updateLotesLinks?.showVerify()
    this.start()
  }
  start() {
    this.#ref.lotes?.reCalculeFieldsByChangeLotes()
  }
}

export class UpdateLotesLinksFieldButton extends FieldButton {
  #form
  #register
  constructor({ form, register, fields, name = 'updateLotesLinks', Logic }) {
    super({ form, register, fields, name, Logic, originClass: UpdateLotesLinksFieldButton })
    super.LDVM = { company: 'public', dataVersionName: 'lotes' }
    this.#form = form
    this.#register = register
  }
  showVerify() {
    const _fieldsToUpdate = new fieldsToUpdate({ fields: [this.#form.lotes, this.#form.poligono] })
    super.field.show = !_fieldsToUpdate.checkAll('isDataIdUpdated')
  }
  async click() {
    window.showOverlay()
    const _fieldsToUpdate = new fieldsToUpdate({ fields: [this.#form.lotes, this.#form.poligono] })
    const { openDialog, closeDialog } = window
    const updateDataIdDialog = new dialog({ data: {
      title: 'É possível atualizar os lotes!',
      text: `Os lotes vinculados a este registro estão na versão '${this.#form.lotes.currentLabel}' e podem ser atualizados para aversão '${this.#form.lotes.lastLabel}'. Deseja fazer a atualização?`,
      buttonYes: 'Sim, pode atualizar!',
      buttonNo: 'Não atualizar',
      action: async () => {
        super.LDVM.updateLinkVersion({ register: this.#register })
        const _iptus = new IPTUsDM({})
        _iptus.setLinkDataVersion({ register: this.#register })
        _iptus.updateLinkDataVersionToLast({ register: this.#register })
        this.#form.lotes.lotesCurrentDataId = super.LDVM.getCurrentDataId({ register: this.#register })
        await _fieldsToUpdate.updateAllDataId()
        this.#form.updateLotesLinks.field.show = false
        window.showSuccess({ text: _fieldsToUpdate.sucessUpdatedAllText() || 'Os lotes foram atualizados.', dismissible: true }),
        window.closeDialog()
      },
    }, openDialog, closeDialog })
    const cannotUpdateDataIdDialog = new dialog({ data: {
      title: 'Problemas na atualização dos lotes!',
      text: _fieldsToUpdate.cannotUpdateAllText(),
      buttonYes: 'Selecionar',
      buttonNo: 'Cancelar',
      action: async () => {
        window.showOverlay()
        window.closeDialog()
        await this.#form.poligono.showUpdateLotesLinksProblem({ dataId: this.#form.lotes.lastDataId })
        window.hideOverlay()
      },
    }, openDialog, closeDialog })
    await this.#form.lotes.build()
    _fieldsToUpdate.checkAll('isDataIdUpdated')
      ? window.showSuccess({ text: `Os lotes já estão atualizados!`, dismissible: true })
      : await _fieldsToUpdate.checkAll('canUpdateDataId')
        ? updateDataIdDialog.open()
        : cannotUpdateDataIdDialog.open()
    window.hideOverlay()
  }
}

export class RecarregarLotesFieldButton extends FieldButton {
  #form
  #register
  constructor({ form, register, fields, name = 'recarregarLotes', Logic }) {
    super({ form, register, fields, name, Logic, originClass: RecarregarLotesFieldButton })
    this.#form = form
    this.#register = register
  }
  async click() {
    // Se clicar no botão sem nada no multilines e na quadra ele trava no overlay
    window.showOverlay()
    await this.#form.lotes.fillAllLotesInfo()
    await this.#form.lotes.reCalculeFieldsByChangeLotes()
    window.hideOverlay()
  }
}

export class ChangeLotesColorsFieldButton extends FieldButton {
  #form
  #applyDescriptionsColors
  constructor({ form, register, fields, name = 'changeLotesColors', Logic }) {
    super({ form, register, fields, name, Logic, originClass: ChangeLotesColorsFieldButton })
    this.#form = form
    this.#applyDescriptionsColors = false
  }
  async click() {
    window.showOverlay()
    this.#applyDescriptionsColors = !this.#applyDescriptionsColors
    this.#applyDescriptionsColors
      ? this.#form.poligono.objects.lotes.map(lote => lote.applyStyle({ name: 'description' }))
      : this.#form.poligono.objects.lotes.map(lote => lote.applyStyle({ name: 'status' }))
    window.hideOverlay()
  }
}

export class lotesMultilines extends multilines {
  #form
  #fields
  #dataId
  #register
  #lastDataId
  #updateInfo
  #iptus
  #Logic
  #lotesCanotUpdate
  #lotesToUpdate
  #lines
  constructor({ form, register, fields, dataId, lastDataId, iptus, Logic }) {
    const name = 'lotes'
    super({ register, fields, name, dataId, Logic, originClass: lotesMultilines })
    super.LDVM = { company: 'public', dataVersionName: 'lotes' }
    this.#form = form
    this.#fields = fields
    this.#dataId = dataId
    this.#register = register
    this.#lastDataId = lastDataId
    this.#iptus = iptus
    this.#Logic = Logic
    this.updateLines = this.updateLines.bind(this)
  }
  async build() {
    await this.loadUpdateInfo()
    return this
  }
  get updateInfo() { return this.#updateInfo }
  get canUpdateDataId() { return !this.#updateInfo.some(info => info.status == false) }
  get lines() { return super.lines }
  set lines(value) { this.#register.lotes = super.lines = value }
  async loadUpdateInfo() {
    this.#updateInfo = await this.getUpdateInfo()
    this.#lotesCanotUpdate = new updateInfo({ data: this.#updateInfo?.filter(info => !info.status) })
    this.#lotesToUpdate = new updateInfo({ data: this.#updateInfo?.filter(info => info.status) })
  }
  async getUpdateInfo() {
    return await this.executeInAllLines({ func: async ({ line, index }) => {
      const _lotes = new LotesDM({})
      await _lotes.form.readRegisterById({ _id: line.lote, project: { sqlc: 1 } })
      return {
        lineIndex: index,
        oldId: line.lote,
        oldLabel: line.link_lote,
        ...(await super.LDVM.canUpdateDataId({
          query: { sqlc: _lotes.form.register?.sqlc },
          project: { sqlc: 1, poligono: 1 }
        }))
        // ,status: false
      }
    }})
  }
  clear() {
    super.clear()
    this.reCalculeFieldsByChangeLotes()
  }
  async clickRemoveAfter({ lineNumber }) {
    await this.reCalculeFieldsByChangeLotes()
    this.#form.poligono.insertTerrenoOfRegister()
    const loteLine = this.#lines?.[lineNumber]
    const lote = loteLine?.lote
    const terrenoLote_id = loteLine?.terrenoLote_id
    if (!lote || !terrenoLote_id) return
    const updateSuccess = await this.#form.updateRegister({})
    if (!updateSuccess) return this.#form.lotes.lines = [...this.#lines]
    await this.deleteLoteForm({ lineNumber })
  }
  clickRemove() {
    this.#lines = [...this.#form.lotes.lines]
  }
  async deleteLoteForm({ lineNumber }) {
    window.showOverlay()
    const fields = [
      {
        "fields": [
          {
            "name": "terreno",
            "label": "Terreno",
            "type": "text",
          },
          {
            "name": "link_terreno",
            "label": "link_Terreno",
            "type": "text"
          },
          {
            "name": "lote",
            "label": "Lote",
            "type": "text"
          }
        ]
      }
    ]
    const line = this.#lines[lineNumber]
    const register = {
      _id: line?.terrenoLote_id,
      terreno: this.#form.register._id,
      link_terreno: this.#form.register.nome,
      lote: line?.lote,
      link_lote: line?.link_lote
    }
    if (!register?.lote || !register._id) return window.hideOverlay()
    const _TerrenosLotes = await new TerrenosLotesForm({ Logic: this.#Logic })
      .build({ register, fields })
    await _TerrenosLotes.form.deleteRegister({})
    window.hideOverlay()
  }
  updateDataId = async () => {
    await this.build()
    const updatedLines = (await this.#updateInfo).map(info => {
      super.lines[info.lineIndex].lote = info.data?._id
      return super.lines[info.lineIndex]
    })
    await this.updateLines({ lines: updatedLines })
  }
  cannotUpdateText = () => this.#lotesCanotUpdate.notEmpty ? `Os lotes: ${this.#lotesCanotUpdate.getPropList('oldLabel')} não foram encontrados na nova base de dados!` : ''
  // cannotUpdateText = () => this.#lotesCanotUpdate.notEmpty ? `Os lotes: ${this.#lotesCanotUpdate.getRegisterPropList(this.#register, 'link_lote')} não foram encontrados na nova base de dados!` : ''
  sucessUpdatedText = () => this.#lotesToUpdate.notEmpty ? `Os lotes: ${this.#lotesToUpdate.getPropList('oldLabel')} foram atualizados!` : ''
  // sucessUpdatedText = () => this.#lotesToUpdate.notEmpty ? `Os lotes: ${this.#lotesToUpdate.getRegisterPropList(this.#register, 'link_lote')} foram atualizados!` : ''
  async updateLines({ lines }) {
    await this.lote.fillLotesOptionsOfQuadra({ quadraInfo: this.#form.quadra.extractInfo() })
    this.lines = lines.map(data => { return {
      lote: data.lote, link_lote: data.link_lote, digito: '', matricula: data.matricula || '', areaIPTU: '', contribuinte: '', codlog: '', testada: '', valorOutorga: '', status: '', valor: data.valor || '', obs: data.obs || '', poligono: ''
    } })
    await Promise.all(super.lines.map(async (line, index) => await this.fillLoteInfo({ _id: line.lote, vmodel: this.#register.lotes[index] })))
    await this.#form.poligono.insertTerrenoOfRegister()
    this.reCalculeFieldsByChangeLotes()
    await this.loadUpdateInfo()
  }
  async reloadLinesInfo() {
    const _lines = this.lines
    this._lines = []
    this.lines = _lines.map(line => { return {
      lote: line.lote, link_lote: '', digito: '', matricula: line.matricula || '', areaIPTU: '', contribuinte: '', codlog: '', testada: '', valorOutorga: '', status: '', valor: line.valor || '', obs: line.obs || '', poligono: ''
    } })
    await this.fillAllLotesInfo()
  }
  async fillLoteInfo({ _id, vmodel }) {
    const lotes2 = new LotesDM({})
    await lotes2
      .form
      .readRegisterById({
        dataId: super.currentDataId,
        _id,
        project: { setor: 1, quadra: 1, lote: 1, condominio: 1, sqlc: 1, poligono: 1 }
      })
    const lote = lotes2.form.register
    vmodel.poligono = lote.poligono || ''
    const iptu = await (new IPTUsDM({})).getIPTU({ action: 'read/one', project: { "NUMERO DO CONTRIBUINTE": 1, "AREA DO TERRENO": 1, "CODLOG DO IMOVEL": 1, "TESTADA PARA CALCULO": 1 }, info: lote, register: this.#register })
    if (iptu) {
      vmodel.digito = (lote.lote && lote.lote != '0000') ? iptu["NUMERO DO CONTRIBUINTE"].split('-')[1] : ''
      vmodel.areaIPTU = jsf.numberOut(iptu["AREA DO TERRENO"] || '0', 2)
      vmodel.contribuinte = (lote.lote && lote.lote != '0000') ? iptu["NUMERO DO CONTRIBUINTE"].replace(/^(\d{3})(\d{3})(\d{4})*/, '$1.$2.$3') : ''
      // tegra não usa a linha acima porque não tem a coluna contribuinte no multilines
      vmodel.codlog = iptu["CODLOG DO IMOVEL"]
      vmodel.testada = iptu["TESTADA PARA CALCULO"] ? jsf.numberOut(iptu["TESTADA PARA CALCULO"], 2) : ''
      const _codlog = iptu["CODLOG DO IMOVEL"].replace('-', '')
      const sq = `${lote.setor}${lote.quadra}`
      const _vtos = new VTOsDM({})
      const vtoCurrentDataId = _vtos.lastDataId
      const _vtos2 = new VTOsDM({ custom: { dataId: vtoCurrentDataId } })
      await _vtos2
        .list
        .read({
          query: { sq: sq, codlog: _codlog },
          project: { valor: 1 }
        })
      if (Array.isArray(_vtos2.list) && _vtos2.list[0]) { vmodel.valorOutorga = _vtos2.list[0].valor }
      vmodel.matricula = vmodel.matricula || await (new ITBIsDM({})).getMatriculaOfLote({ setor: lote.setor, quadra: lote.quadra, lote: lote.lote })
    }
  }
  async reCalculeFieldsByChangeLotes() {
    { await (new IPTUsDM({})).calculeSumAreaIPTU({ register: this.#register, fields: this.#fields }) }
    { await (new VTOsDM({})).calculeMaxVTO({ fields: this.#fields, lotes: this.#register.lotes }) }
    this.#form.testadas.update()
  }
  async fillAllLotesInfo() {
    await Promise.all(this.#form.register.lotes.map(async loteLine => {
      await this.fillLoteInfo({ _id: loteLine.lote, vmodel: loteLine })
    }))
  }
  findLineNumberPoligon = function({ poligono, link_lote }) {
    const findId = element => element.info?.Lote == link_lote ? true : false
    return poligono.findIndex(findId)
  }
  async getStatusColorPolygonOption({ lote }) {
    const loteId = lote._id
    const statusId = this.#form.register.lotes?.find(line => line.lote == loteId)?.status
    // const statusId = this.lines?.find(line => line.lote == loteId).status
    const statusColor = await this.getStatusColor({ status: statusId })
    return statusColor
      ? { ...(statusColor && { fillColor: statusColor, fillOpacity: 0.7 }) }
      : {}
  }
  async getStatusColor({ status }) {
    const statusLotes = new StatusLotes({})
    await statusLotes
      .form
      .readRegisterById({
        _id: status,
        project: { color: 1 }
      })
    return statusLotes.form.register ? statusLotes.form.register.color : ''
  }
  async updateLotesAux() {
    window.showOverlay()
    super.LDVM.updateLinkVersion({ register: this.#register })
    { (new IPTUsDM({})).updateLinkDataVersionToLast({ register: this.#register }) }
    this.#form.poligono.dataId = super.LDVM.getCurrentDataId({ register: this.#register })
    await this.updateLines({ lines: this.#form.poligono.polygonsAux })
    this.#form.poligono.closeMapAux()
    await this.#form.poligono.insertTerrenoOfRegister()
    this.#form.updateLotesLinks.field.show = false
    window.showSuccess({ text: `Os lotes foram atualizados com sucesso! Ainda é necessário gravar o registro.`, dismissible: true })
    window.hideOverlay()
  }
}

export class LotesLoteSelect extends FieldSelect {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'lotes', name = 'lote', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: LotesLoteSelect })
    super.LDVM = { company: 'public', dataVersionName: 'lotes' }
    this.#form = form
    this.#Logic = Logic
  }
  async change({ value, vmodel }) {
    await this.#form.lotes.fillLoteInfo({ _id: value, vmodel })
    await this.#form.lotes.reCalculeFieldsByChangeLotes()
    this.#form.poligono.insertTerrenoOfRegister()
    await this.#form.lotes.build()
  }
  async fillLotesOptionsOfQuadra({ quadraInfo }) { // eslint-disable-line
    const lotes = await this.#getLotesOfQuadra({ quadraInfo })
    const options = this.#getSelectOptionsOfLotes({ lotes })
    this.field.options = options
    this.field.loading = 'false'
    // fieldRestricoes.loading = FormLines.styles["--over-color"]
    this.#form.restricoes.lote.field.options = options
    // fieldRestricoes.loading = 'false'
  }
  async #getLotesOfQuadra({ quadraInfo }) { // eslint-disable-line
    const lotes = new LotesDM({})
    await lotes
      .list
      .read({
        dataId: super.currentDataId,
        query: {
          tipoQuadra: quadraInfo.tipoQuadra,
          setor: quadraInfo.setor,
          quadra: quadraInfo.quadra
        },
        project: { lote: 1, condominio: 1 }
      })
    return lotes
  }
  #getSelectOptionsOfLotes({ lotes }) { // eslint-disable-line
    let options = []
    options = lotes.list.map(e => ({ option: { text: `${e.lote}${(e.condominio && e.condominio != '00') ? ' (' +  e.condominio + ')' : ''}`, value: e._id } })).sort((a, b) => a.option.text.localeCompare(b.option.text))
    options.unshift({ "option": { "text": "", "value": "" } })
    return options
  }
}
export class LotesDigitoText extends FieldText {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'lotes', name = 'digito', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: LotesDigitoText })
    this.#form = form
    this.#Logic = Logic
  }
}

export class LotesAreaIPTUText extends FieldText {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'lotes', name = 'areaIPTU', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: LotesAreaIPTUText })
    this.#form = form
    this.#Logic = Logic
  }
  async keyup() {
    (await new IPTUsDM({})).calculeSumAreaIPTU({ register: this.#form.register, fields: this.#form.fields })
  }

}
export class LotesCodlogText extends FieldText {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'lotes', name = 'codlog', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: LotesCodlogText })
    this.#form = form
    this.#Logic = Logic
  }
  keyup() {
    this.#form.testadas.update()
  }
}

export class LotesTestadaText extends FieldText {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'lotes', name = 'testada', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: LotesTestadaText })
    this.#form = form
    this.#Logic = Logic
  }
  keyup() {
    this.#form.testadas.update()
  }
}

export class LotesValorOutorgaText extends FieldText {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'lotes', name = 'valorOutorga', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: LotesValorOutorgaText })
    this.#form = form
    this.#Logic = Logic
  }
  async keyup() {
    (await new VTOsDM({})).calculeMaxVTO({ fields: this.#form.fields, lotes: this.#form.register.lotes })
  }
}

export class LotesStatusLinkSimple extends FieldLinkSimple {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'lotes', name = 'status', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: LotesStatusLinkSimple })
    this.#form = form
    this.#Logic = Logic
  }
  change() {
    this.#form.poligono.insertTerrenoOfRegister()
  }
}
export class LotesDetalhesFieldButton extends FieldButton {
  #form
  #Logic
  constructor({ form, register, fields, multiline = 'lotes', name = 'detalhes', Logic }) {
    super({ form, register, fields, multiline, name, Logic, originClass: LotesDetalhesFieldButton })
    this.#form = form
    this.#Logic = Logic
  }
  async #buildTextToolTipNegociacoesPart({ line }) { // eslint-disable-line
    if (!line.terrenoLote_id && !line.valor) return ''
    const firstOferta = this.#form.ofertas.value[0]
    if (!line.terrenoLote_id && line.valor) return `
      <br> &bull; <strong>Negociações: </strong> 1
      <br> - Última: ${firstOferta?.data || ''} (R$ ${line?.valor})
    `
    const _terrenosLotesDM = await (new TerrenosLotesDM({ Logic: this.#Logic }))
      .getRegister({ _id: line.terrenoLote_id, project: { negociacoes: 1 } })
    const register = _terrenosLotesDM.form.register
    if (register?.negociacoes) return `
      <br> &bull; <strong>Negociações: </strong> ${register.negociacoes.length}
      <br> - Última: ${register.negociacoes.getLast().data || ''} (R$ ${register.negociacoes.getLast().valor || ''})
    `
  }
  async #buildTextToolTip({ line }) { // eslint-disable-line
    const { iptu, itbi } = await (new TerrenosLotesForm({ Logic: this.#Logic })).getInfos({ register: line, modelClass: true })
    const negociacoesPart = await this.#buildTextToolTipNegociacoesPart({ line })
    const transacoes = itbi?.list[0]?.data
    const lastTransacao = transacoes?.last
    super.tooltip = ''
    super.tooltip = `
      <strong>Mais informações</strong>
      ${iptu.cep ? '<br> &bull; <strong>CEP: </strong>' + iptu.cep : '' }
      ${iptu.endereco ? '<br> &bull; <strong>Endereço: </strong>' + iptu.endereco : '' }
      ${iptu.tipoDeUso ? '<br> &bull; <strong>Tipo de Uso: </strong>' + iptu.tipoDeUso : '' }
      ${iptu.areaConstruida ? '<br> &bull; <strong>Área Construída: </strong>' + iptu.areaConstruida : '' }
      ${iptu.anoConstrucao ? '<br> &bull; <strong>Ano Construção: </strong>' + iptu.anoConstrucao : '' }
      ${negociacoesPart}
      ${transacoes && transacoes.length != 0 ? '<br> &bull; <strong>Transações: </strong>' + transacoes.length : '' }
      ${lastTransacao ? '<br> - Última: ' + lastTransacao.data + ' (R$' + lastTransacao.valorImovel + ')' : '' }
      ${line.obs ? '<br> &bull; <strong>Observações: </strong>' + line.obs : '' }
    `
  }
  tooltip({ line }) {
    this.#buildTextToolTip({ line })
  }
  async #createLoteForm({ loteLine, lineNumber }) { // eslint-disable-line
    window.showOverlay()
    const fields = [
      {
        "fields": [
          {
            "name": "terreno",
            "label": "Terreno",
            "type": "text",
          },
          {
            "name": "link_terreno",
            "label": "link_Terreno",
            "type": "text"
          },
          {
            "name": "lote",
            "label": "Lote",
            "type": "text"
          },
          {
            "name": "poligono",
            "label": "Poligono",
            "type": "map"
          },
          {
            "name": "poligono",
            "label": "Poligono",
            "type": "map"
          },
          {
            "name": "negociacoes",
            "type": "multilines",
            "label": "Negociações",
            "fields": [
              {
                "name": "data",
                "label": "Data",
                "type": "datePicker",
              },
              {
                "name": "valor",
                "label": "Valor (R$)",
                "type": "text",
              },
              {
                "name": "valorporm2",
                "label": "R$ / m²",
                "type": "text",
              },
              {
                "name": "obs",
                "label": "Observações",
                "type": "text",
              }
            ]
          }
        ]
      }
    ]
    const negociacoesMultilines = []
    negociacoesMultilines.push({ valor: loteLine.valor })
    const LDVM = new linkDataVersionsManager({ company: 'public', dataVersionName: 'lotes' })
    const versionDataId = LDVM.getLastDataId()
    const register = {
      firstEnter: true,
      terreno: this.#form.register._id,
      link_terreno: this.#form.register.nome,
      lote: loteLine.lote,
      link_lote: loteLine.link_lote,
      negociacoes: negociacoesMultilines
    }
    LDVM.setLinkDataVersion({ register, versionDataId })
    const terrenosLotes = await new TerrenosLotesForm({ Logic: this.#Logic })
      .build({ register, fields, notStart: true })
    await terrenosLotes
      .form
      .createRegister({
        success: {
          skipDefault: true,
          success: async ({ registerCreated }) => {
            this.#form.lotes.updateLine({ lineNumber, values: { terrenoLote_id: registerCreated._id } })
            await this.#form.updateRegister({})
            window.hideOverlay()
          }
        },
        fail: {
          skipDefault: true,
          fail: () => {
            window.hideOverlay()
            window.showError({ text: 'Ocorreu um problema ao gerar o formulário de lotes', dismissible: true, time: 2000 })
          }
        }
      })
  }
  async validationLoteLines({ lineNumber }) {
    const lotes = this.#form.lotes.lines
    const loteLine = lotes?.[lineNumber]
    const lote = loteLine?.lote
    const terrenoNotSaved = !this.#form.register._id
    if (terrenoNotSaved) {
      window.showWarning({ text: 'É necessário gravar o terreno antes de acessar os detalhes', dismissible: true, time: 5000 })
      return false
    }
    if (!lote) {
      window.showWarning({ text: 'Lote inválido ou não encontrado', dismissible: true, time: 5000 })
      return false
    }
    const someInvalid = lotes.some((line, index) => {
      if (index === lineNumber) return false
      return !line.lote
    })
    if (someInvalid) {
      window.showError({ text: 'Todos os campos Lotes precisam estar preenchidos', dismissible: true, time: 5000 })
      return false
    }
    window.showOverlay()
    const updateSuccess = await this.#form.updateRegister({})
    if (!updateSuccess) {
      window.hideOverlay()
      return false
    }
    window.hideOverlay()
    return true
  }
  async clickDetalhes({ lineNumber }) {
    const lotes = this.#form?.lotes?.lines
    const loteLine = lotes?.[lineNumber]
    const ok = await this.validationLoteLines({ lineNumber })
    if (!ok) return
    const notHasTerrenoLoteFormRegister = !loteLine.terrenoLote_id
    if (notHasTerrenoLoteFormRegister) { await this.#createLoteForm({ loteLine, lineNumber }) }
    window.showOverlay()
    const mainMenu = await get_info.getMenuObject({ hmenu: 'data', dataId: 'terrenos' })
    const id = loteLine.terrenoLote_id
    window.routerPush({ name: 'data', query: { hmenuOpened: 'Dados', menuId: 'terrenos_lotes', menuOpened: 'Lotes Terrenos', mainMenuId: mainMenu.dataId, mainMenuOpened: 'Terrenos > Lote', tabNumber: 2, id } })
      .then(()=>{ window.hideOverlay() })
      .catch((error)=>{ console.log(error); window.hideOverlay() })
    // jsf.openInNewWindow({ name: 'data', query })
  }
}

export class TestadasMultilines extends multilines {
  #form
  #Logic
  constructor({ form, register, fields, name = 'testadas', Logic }) {
    super({ form, register, fields, name, Logic, originClass: TestadasMultilines })
    this.#form = form
    this.#Logic = Logic
  }
  update() {
    const _testadas = this.#form.register.testadas
    this.#form.register.testadas = []
    const _lotes = this.#form.register.lotes.filter(lote => lote.codlog != undefined)
    const getLogradouro = async (codlog) => {
      const regexCodlog = /^\d{5,6}-\d$/
      if (!codlog || !regexCodlog.test(codlog)) { return '' }
      const _testada = _testadas.find(testada => testada.codlog == codlog)
      if (_testada && _testada.logradouro) { return _testada.logradouro }
      const _iptus = new IPTUsDM({})
      const dataId = _iptus.getCurrentDataId({ register: this.#form.register })
      await _iptus
        .form
        .readRegister({
          dataId,
          query: { ["CODLOG DO IMOVEL"]: codlog },
          project: { "NOME DE LOGRADOURO DO IMOVEL": 1 },
          fail: {
            skipDefault: true,
            fail: () => {}
          }
        })
      return _iptus.form.register?.["NOME DE LOGRADOURO DO IMOVEL"]
    }
    const sumTestadas = (codlog) => jsf.numberOut(_lotes.reduce((sum, lote) => sum += lote.codlog == codlog ? jsf.numberIn(lote.testada) : 0, 0), 2, "0,00")
    jsf.executeIfUniq({ array: _lotes, prop: "codlog", func: async (lote) => { this.#form.register.testadas.push({ logradouro: await getLogradouro(lote.codlog), codlog: lote.codlog, testada: sumTestadas(lote.codlog) }) } })
  }
}